var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CurrentStockAdjustTemp',{attrs:{"goods-option":"S0106","goods-type":"구매품"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }